module.exports = {
  addEventListener: require('./add-event-listener'),
  createDom: require('./create-dom'),
  getBoundingClientRect: require('./get-bounding-client-rect'),
  getHeight: require('./get-height'),
  getOuterHeight: require('./get-outer-height'),
  getOuterWidth: require('./get-outer-width'),
  getRatio: require('./get-ratio'),
  getStyle: require('./get-style'),
  getWidth: require('./get-width'),
  modifyCSS: require('./modify-css'),
  requestAnimationFrame: require('./request-animation-frame')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/dom/index.js
// module id = 235
// module chunks = 0 1 2